import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";

import { ICONS, SvgIcon } from "../Common/Icons";
import Slide from "../Dashboard/Slide";
import styles from "./DashboardCompositionPage.local.scss";
import { connect } from "react-redux";
import { Switch, Tooltip } from "antd";

class DashboardDisposition extends Component {
  render() {
    const {
      slides,
      composition: { labels, slidesOrder, isEditable, organizations },
      selectedLanguage,
      privacyState,
      withoutHeader,
      backOffice
    } = this.props;

    // pour demonstration "Performance note"
    //https://stackoverflow.com/a/15998003

    // console.time("filter function");
    // let dashboardSlides = slides.filter(({ id }) =>
    //   [...slidesOrder].some(e => id === e)
    // );
    // console.timeEnd("filter function");

    // console.time("loop");
    let sortedSlides = [];
    for (let index = 0; index < slidesOrder.length; index++) {
      for (let i = 0; i < slides.length; i++) {
        if (slides[i].id === slidesOrder[index]) {
          sortedSlides[index] = slides[i];
          break;
        }
      }
    }
    return (
      <div>
        {!backOffice && (
          <div
            className={classnames(
              styles.crosssharing_container,
              withoutHeader ? styles.without_header : ""
            )}
          >
            <div style={{ display: "flex" }}>
              <span className={styles.labels}> {_("visibility")} :</span>
              <div className={styles.visibility_options}>
                <label
                  className={styles.container}
                  onChange={this.props.handleChangePrivacyState}
                >
                  <input
                    type="radio"
                    checked={!privacyState ? "checked" : null}
                    name="radio"
                    value="private"
                    disabled={!!(organizations && organizations.length > 0)}
                  />
                  <span className={styles.checkmark} />
                  <span className={styles.labels_option}>{_("private")}</span>
                </label>
                <div className={styles.separator} />
                <label
                  className={styles.container}
                  onChange={this.props.handleChangePrivacyState}
                >
                  <input
                    type="radio"
                    checked={privacyState ? "checked" : null}
                    name="radio"
                    value="public"
                    disabled={!!(organizations && organizations.length > 0)}
                  />
                  <span className={styles.checkmark} />
                  <span className={styles.labels_option}>
                    {_("sharedWithCommunity")}
                  </span>
                </label>
              </div>
            </div>
            {privacyState ? (
              <div
                className={classnames(
                  styles.config_check,
                  withoutHeader ? styles.without_header : ""
                )}
              >
                <div>
                  <span className={styles.sub_title}>
                    <Tooltip
                      placement="top"
                      title={_("dashboardEditableInfos")}
                    >
                      <img
                        data-for="info__undefined"
                        data-tip=""
                        className={styles.comment_icon}
                        src="/img/icons/info.svg"
                        alt=""
                      />{" "}
                    </Tooltip>
                    {_("editableTemplate")}
                  </span>
                </div>
                <Switch
                  className={styles.switch}
                  checked={isEditable}
                  onChange={() => this.props.onChangeIsEditable()}
                  disabled={!!(organizations && organizations.length > 0)}
                />
              </div>
            ) : null}
          </div>
        )}
        <div
          className={classnames(
            styles.tabs,
            withoutHeader ? styles.without_header : ""
          )}
        >
          <div
            className={
              styles.tab_badge +
              " " +
              (selectedLanguage === "fr" ? styles.tab_badge_active : "")
            }
            onClick={() => this.props.handleSelectInputsLanguage("fr")}
          >
            <span className={styles.span_label}>
              <img src={"/img/icons/fr_flag.png"} alt={""} width={22} />
              {_("French")}
            </span>
          </div>
          <div
            className={
              styles.tab_badge +
              " " +
              (selectedLanguage === "en" ? styles.tab_badge_active : "")
            }
            onClick={() => this.props.handleSelectInputsLanguage("en")}
          >
            <span className={styles.span_label}>
              <img src={"/img/icons/en_flag.png"} alt={""} width={22} />
              {_("English")}
            </span>
          </div>
          <div
            className={
              styles.tab_badge +
              " " +
              (selectedLanguage === "nl" ? styles.tab_badge_active : "")
            }
            onClick={() => this.props.handleSelectInputsLanguage("nl")}
          >
            <span className={styles.span_label}>
              <img src={"/img/icons/nl_flag.png"} alt={""} width={22} />
              {_("Dutch")}
            </span>
          </div>
        </div>
        <div className={styles.dashboard_header}>
          <span
            className={classnames(
              styles.dashboard_icon,
              withoutHeader ? styles.without_header : "",
              backOffice ? styles.backOffice : ""
            )}
          >
            <SvgIcon
              icon={ICONS.DASHBOARD_PAGE_ICON}
              className={"light-sub-menu-icon"}
            />
          </span>
          <input
            id={"dashboard_title"}
            type={"text"}
            className={styles.dashboard_title}
            placeholder={
              selectedLanguage == "fr"
                ? _("frTitle")
                : selectedLanguage == "en"
                  ? _("enTitle")
                  : _("nlTitle")
            }
            value={labels ? labels[selectedLanguage] : ""}
            onChange={e =>
              this.props.handleChangeDashboardLabel(selectedLanguage, e)
            }
            required={true}
          />
          <div
            className={classnames(
              styles.dashboard_title_button_container,
              backOffice ? styles.backOffice : ""
            )}
          >
            <button
              type="button"
              className={styles.dashboard_title_action_button}
            >
              <SvgIcon icon={ICONS.Validate} className={""} />
            </button>
            <button
              type="button"
              className={styles.dashboard_title_action_button}
              onClick={() =>
                this.props.handleBackUpCompositionLabel(selectedLanguage)
              }
            >
              <img src={"/img/icons/close.svg"} alt={""} />
            </button>
          </div>
        </div>
        <div>
          {sortedSlides.map((slide, i) => {
            return (
              <div
                id={"slide_container_" + slide.id}
                className={classnames(styles.slide_container)}
                key={i}
              >
                <span className={styles.slide_number}> {i + 1} </span>

                <div className={styles.dashboard_slide_min}>
                  <Slide slide={slide} isResponsive={false} />
                </div>

                <div className={styles.slides_order_container}>
                  <button
                    type="button"
                    className={styles.slides_order_button}
                    onClick={() => this.props.handleMoveToTop(slide.id)}
                  >
                    <SvgIcon icon={ICONS.DoubleArrowUp} className={""} />
                  </button>
                  <button
                    type="button"
                    className={styles.slides_order_button}
                    onClick={() => this.props.handleSwapUp(slide.id)}
                  >
                    <SvgIcon icon={ICONS.SimpleArrowUp} className={""} />
                  </button>

                  <button
                    type="button"
                    className={classnames(
                      styles.slides_order_button,
                      styles.down_arrow
                    )}
                    onClick={() => this.props.handleSwapDown(slide.id)}
                  >
                    <SvgIcon icon={ICONS.SimpleArrowUp} className={""} />
                  </button>
                  <button
                    type="button"
                    className={classnames(
                      styles.slides_order_button,
                      styles.down_arrow
                    )}
                    onClick={() => this.props.handleMoveToBottom(slide.id)}
                  >
                    <SvgIcon icon={ICONS.DoubleArrowUp} className={""} />
                  </button>
                </div>

                <span
                  className={styles.slide_remove}
                  onClick={() =>
                    this.props.handleRemoveSlideFromDashboard(slide.id)
                  }
                >
                  <SvgIcon icon={ICONS.REMOVE} className={""} />
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  withoutHeader: state.auth.withoutHeader,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(DashboardDisposition);



// WEBPACK FOOTER //
// ./src/components/DashboardComposition/DashboardDisposition.js